module.exports = __webpack_public_path__ + "img/fireAlarm.4c7d2e97.png";